import {
  CustomFormFieldDefinition,
  ICustomFormFieldExternalOptions
} from '@publishing-engine/domain/types/article';
import asDependentFieldComponent from 'src/pages/Organization/public/Journal/SubmissionUpload/components/common/asDependentFieldComponent';

import FormFieldCheckbox from './FormFieldCheckbox';
import FormFieldSelect from './FormFieldSelect';
import FormFieldTextInput from './FormFieldText';
import FormFieldTextInputArray from './FormFieldTextInputArray';
import FormFieldTextArea from './FormFieldTextArea';
import FormFieldRadioGroup from './FormFieldRadioGroup';
import FormFieldDependentSelect from './FormFieldDependentSelect';
import FormFieldDependentTextArea from './FormFieldDependentTextArea';
import FormFieldDependentTextInput from './FormFieldDependentTextInput';
import FormFieldMultipleFileUpload from './FormFieldMultipleFileUpload';
import FormFieldCheckboxArray from './FormFieldCheckboxArray';
import FormFieldNumber from './FormFieldNumber';
import FormFieldDate from './FormFieldDate';
import { IRoleType } from '@publishing-engine/domain/models';
import FormFieldSingleFileUpload from './FormFieldSingleFileUpload';
import FormFieldInteger from './FormFieldInteger';
import FormFieldRichTextInput from './FormFieldRichText';
import FormFieldStringInputArray from './FormFIeldStringInputArray';
import FormFieldFocusSelect from './FormFieldFocusSelect';

// Define the components map after all imports
const componentsMap: Record<
  CustomFormFieldDefinition['component'],
  React.ComponentType<any> | null
> = {
  'Custom:Checkbox': FormFieldCheckbox,
  'Custom:Select': FormFieldSelect,
  'Custom:TextInput': FormFieldTextInput,
  'Custom:TextInputArray': FormFieldTextInputArray,
  'Custom:TextArea': FormFieldTextArea,
  'Custom:RadioGroup': FormFieldRadioGroup,
  'Custom:DependentSelect': FormFieldDependentSelect,
  'Custom:DependentTextArea': FormFieldDependentTextArea,
  'Custom:DependentTextInput': FormFieldDependentTextInput,
  'Custom:FileUploadArray': FormFieldMultipleFileUpload,
  'Custom:CheckboxArray': FormFieldCheckboxArray,
  'Custom:RecommendedReviewers': null,
  'Custom:FileUpload': FormFieldSingleFileUpload,
  'Custom:Polar': null,
  'Custom:NumberInput': FormFieldNumber,
  'Custom:DateInput': FormFieldDate,
  'Custom:InfoText': null,
  'Custom:IntegerInput': FormFieldInteger,
  'Custom:RichTextInput': FormFieldRichTextInput,
  'Custom:StringInputArray': FormFieldStringInputArray,
  'Custom:FocusSelect': FormFieldFocusSelect
};

type IProps = {
  config: CustomFormFieldDefinition;
  submissionContextId?: string;
  submissionId?: string;
  placeholder?: string;
  options?: ICustomFormFieldExternalOptions;
  roleType?: IRoleType;
  isEditingAllowed?: boolean;
};

const CustomFormFieldComponent: React.FC<IProps> = props => {
  const Component =
    componentsMap[props.config.component as keyof typeof componentsMap];

  return Component ? <Component {...props} /> : null;
};

export default asDependentFieldComponent(CustomFormFieldComponent);
